import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import resize from '@alpinejs/resize';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import htmx from 'htmx.org';

// Register Alpine AJAX plugin
Alpine.plugin(ajax);

// x-collapse — animates an element between its natural height and zero. Used by
// the Accordion's trays. A CSS transition can't do this on its own: `height`
// only animates between two known values, and the whole point of a tray is that
// its height is whatever the content turns out to be. The alternative,
// max-height with a guessed ceiling, either clips long content or spends the
// tail of the transition animating empty space.
Alpine.plugin(collapse);

// x-resize — ResizeObserver-backed size watching. Used by the header to keep
// --og--header-bar-h and --og--mega-left in step with the bar. A window resize
// listener isn't enough: those measurements also change when the logo image
// finishes loading or a webfont swaps in, neither of which resizes the window.
Alpine.plugin(resize);

// x-trap — focus management for the mobile navigation. Without it, opening the
// drawer leaves focus on the page behind it and Tab walks straight out of the
// menu into content the user can't see.
Alpine.plugin(focus);

window.Alpine = Alpine;
window.htmx = htmx;

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    // Shared nav state. The top-bar strip and the submenu sheets are siblings in
    // different parts of the header, so the strip can't read the sheet's `open`
    // directly — it goes through here instead.
    Alpine.store('nav', { panelOpen: false });

    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();
});

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });